import { render, staticRenderFns } from "./dealHistory.vue?vue&type=template&id=dc5737b6&scoped=true&"
import script from "./dealHistory.vue?vue&type=script&lang=js&"
export * from "./dealHistory.vue?vue&type=script&lang=js&"
import style0 from "./dealHistory.vue?vue&type=style&index=0&id=dc5737b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5737b6",
  null
  
)

export default component.exports